<template>
    <MenuTemplate></MenuTemplate>
  </template>
  
  <script>
  import MenuTemplate from "@/views/user/Menu_6/MenuTemplate.vue";
  export default {
    name: "dataList",
    components: { MenuTemplate },
    data() {
      return {};
    },
    watch: {},
    created() {},
    mounted() {},
    methods: {},
  };
  </script>
  